/**
 * Level registry. Each `LEVEL_N` lives in its own file (`level1.ts`, `level2.ts`,
 * etc.) so multiple agents can add levels in parallel without touching the same
 * file. To add Level N, create `levelN.ts`, import + append it here.
 *
 * See `src/levels/AGENT_PROMPT.md` for the per-level conventions.
 */

import { LEVEL_1 } from './level1';
import { LEVEL_2 } from './level2';
import { LEVEL_3 } from './level3';
import { LEVEL_4 } from './level4';
import { LEVEL_5 } from './level5';
import { LEVEL_6 } from './level6';
import { LEVEL_7 } from './level7';
import { LEVEL_8 } from './level8';
import { LEVEL_9 } from './level9';
import { LEVEL_10 } from './level10';
import { LEVEL_11 } from './level11';
import type { LevelConfig } from './portHelpers';

export type { WallPortConfig, LevelConfig } from './portHelpers';

// Full Steps 1–11 shipped — array indices and `step` numbers now match 1:1.
export const LEVELS: LevelConfig[] = [
  LEVEL_1,
  LEVEL_2,
  LEVEL_3,
  LEVEL_4,
  LEVEL_5,
  LEVEL_6,
  LEVEL_7,
  LEVEL_8,
  LEVEL_9,
  LEVEL_10,
  LEVEL_11,
];
